import { SurveyQuestionTagboxItem } from 'survey-react-ui';

import classNames from 'classnames';

import { Button } from '../../Button';

import styles from '../../Form/FormCheckboxToggle/FormCheckboxToggleItem/FormCheckboxToggleItem.module.scss';

export class SurveyTagboxItem extends SurveyQuestionTagboxItem {
  private onToggle = (): void => {
    if (this.item.selected) {
      this.question.dropdownListModel.deselectItem(this.item.value);
    } else {
      this.question.dropdownListModel.selectItem(this.item.value);
    }
  };

  protected renderElement(): JSX.Element {
    return (
      <Button
        block={false}
        disabled={this.item.disabled}
        variant={this.item.selected ? 'primary' : 'secondary'}
        onClick={() => this.onToggle()}
        className={classNames(styles.root, {
          [styles.inactive]: !this.item.selected,
        })}
      >
        {this.renderLocString(this.item.locText)}
      </Button>
    );
  }
}
